// Modal "Confirmar caja" — preview pre-impresión.
//
// Sustituye a la sección "En la caja actual" que vivía en la pantalla
// principal. Se abre al pulsar el botón "Caja" del footer y muestra:
//   - lista de items que llevará la caja (con lotes)
//   - peso total estimado (si calculable)
//   - palet de destino (si hay activo) o "Sin palet"
// Resuelve con `true` si el operario confirma, `false` si cancela.

import { icon } from './icons.js';

const escapeHtml = (s) => String(s ?? '').replace(/[&<>"']/g,
  c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));

let _host = null;
function _close() { if (_host) { _host.remove(); _host = null; } }

export function openConfirmarCajaModal({ numeroCaja, lineas, pesoKg, paletActivo }) {
  return new Promise((resolve) => {
    _host = document.createElement('div');
    document.body.appendChild(_host);

    const itemsHTML = lineas.map(l => {
      const cant = Number.isInteger(l.cantidad) ? l.cantidad : l.cantidad;
      const lote = l.lote ? `<span style="color:var(--c-fg-muted);font-size:var(--fs-xs);"> · lote ${escapeHtml(l.lote)}</span>` : '';
      return `
        <li style="display:flex;justify-content:space-between;gap:0.5rem;padding:0.4rem 0;border-bottom:1px dashed var(--c-border);font-size:var(--fs-sm);">
          <span>${escapeHtml(l.descripcion)}${lote}</span>
          <span style="font-weight:600;">×${cant}</span>
        </li>`;
    }).join('');

    const paletBadge = paletActivo
      ? `<div style="
            background: var(--c-accent);
            color: var(--c-accent-fg);
            padding: 0.5rem 0.75rem;
            border-radius: var(--radius);
            font-weight: 600;
            display: flex; align-items: center; gap: 0.5rem;
            font-size: var(--fs-sm);
          ">
            <span style="display:inline-flex;">${icon('layers', { size: 18 })}</span>
            <span>Se asignará al <strong>Palet #${paletActivo.numero}</strong></span>
          </div>`
      : `<div style="
            background: var(--c-pending-bg);
            color: var(--c-fg-muted);
            padding: 0.5rem 0.75rem;
            border-radius: var(--radius);
            font-size: var(--fs-sm);
            display: flex; align-items: center; gap: 0.5rem;
          ">
            <span style="display:inline-flex;">${icon('package', { size: 18 })}</span>
            <span>Caja suelta — sin palet asignado</span>
          </div>`;

    const pesoLine = pesoKg != null
      ? `<div style="display:flex;justify-content:space-between;padding-top:0.5rem;border-top:1px solid var(--c-border);font-size:var(--fs-sm);">
          <span style="color:var(--c-fg-muted);">Peso estimado</span>
          <strong>${pesoKg.toFixed(3)} kg</strong>
        </div>`
      : '';

    _host.innerHTML = `
      <div class="scrim fade-in"><div class="modal" style="max-height:90dvh;overflow-y:auto;">
        <h2>${icon('package', { size: 22 })} Caja #${numeroCaja} · ${lineas.length} ${lineas.length === 1 ? 'producto' : 'productos'}</h2>
        ${paletBadge}
        <div>
          <ul style="list-style:none;margin:0;padding:0;">
            ${itemsHTML}
          </ul>
          ${pesoLine}
        </div>
        <p class="hint">Al confirmar, se imprime la etiqueta SSCC y la caja queda registrada.</p>
        <div class="actions">
          <button class="btn --ghost" id="cc-cancel">Cancelar</button>
          <button class="btn --primary" id="cc-confirm">Imprimir etiqueta</button>
        </div>
      </div></div>`;

    _host.querySelector('#cc-cancel').addEventListener('click', () => { _close(); resolve(false); });
    _host.querySelector('#cc-confirm').addEventListener('click', () => { _close(); resolve(true); });
  });
}
